import { useState } from "react";
import Cookies from "js-cookie";

export default function useToken() {
  const getToken = () => Cookies.get("cargobase_usertoken");

  const [token, setToken] = useState(getToken());

  const saveToken = (userToken) => {
    Cookies.set("cargobase_usertoken", userToken, {
      expires: 7,
    });
    setToken(userToken);
  };

  const clearToken = () => {
    Cookies.remove("cargobase_usertoken");
    setToken("");
  };

  return {
    setToken: saveToken,
    token,
    clearToken,
  };
}
